<ion-header mode="ios">
  <ion-toolbar>
    <ion-title>{{ 'pages.fund-cash.purchase.title' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button color="primary" (click)="close()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <ui-current-cdc [project]="project" [showRole]="false"></ui-current-cdc>
</ion-header>

<ion-content class="ion-padding">
  <div class="flex flex-column min-height-100">
    <front-end-fund-cash-purchase-form
      *ngIf="form"
      [id]="'fund-cash-purchase-form'"
      [form]="form"
      [project]="project"
      [budgetProjectTasks]="budgetProjectTasks"
      [allowedSubtasks]="allowedSubtasks"
      [showRecurring]="true"
      (submitted)="submit($event)"
      #purchaseForm
    ></front-end-fund-cash-purchase-form>

    <ui-bottom-actions>
      <div class="flex flex-column gap-8">
        <ng-container *ngIf="cardSpendingLimits$ | async as limits">
          <span *ngIf="limits?.dailyLimit" class="font-regular w-full ion-text-center">
            {{ 'pages.fund-cash.purchase.form.cardLimit.daily' | translate: { limit: (limits.dailyLimit | currency: 'EUR') } }}
          </span>
          <span *ngIf="limits?.weeklyLimit" class="font-regular w-full ion-text-center">
            {{ 'pages.fund-cash.purchase.form.cardLimit.weekly' | translate: { limit: (limits.weeklyLimit | currency: 'EUR') } }}
          </span>
          <span *ngIf="limits?.monthlyLimit" class="font-regular w-full ion-text-center">
            {{ 'pages.fund-cash.purchase.form.cardLimit.monthly' | translate: { limit: (limits.monthlyLimit | currency: 'EUR') } }}
          </span>
          <span *ngIf="limits?.yearlyLimit" class="font-regular w-full ion-text-center">
            {{ 'pages.fund-cash.purchase.form.cardLimit.yearly' | translate: { limit: (limits.yearlyLimit | currency: 'EUR') } }}
          </span>
          <span *ngIf="limits?.allTimeLimit" class="font-regular w-full ion-text-center">
            {{ 'pages.fund-cash.purchase.form.cardLimit.allTime' | translate: { limit: (limits.allTimeLimit | currency: 'EUR') } }}
          </span>
          <span *ngIf="limits?.perAuthorizationLimit" class="font-regular w-full ion-text-center">
            {{
              'pages.fund-cash.purchase.form.cardLimit.perAuthorization'
                | translate: { limit: (limits.perAuthorizationLimit | currency: 'EUR') }
            }}
          </span>
        </ng-container>
        <ion-button
          type="submit"
          form="fund-cash-purchase-form"
          color="primary"
          [disabled]="isFormInvalid"
          data-cy="Purchase from fund cash"
        >
          {{ 'pages.fund-cash.purchase.form.submitButton' | translate }}
        </ion-button>

        <ion-button *ngIf="canDeleteCashFund" type="button" fill="clear" (click)="deletePurchase()">
          {{ 'pages.fund-cash.purchase.delete' | translate }}
        </ion-button>
      </div>

      <div class="divider flex ion-align-items-center justify-content-center">
        <ion-button fill="clear" type="submit" form="fund-cash-purchase-form" (click)="setIsDraft()"
          >{{ 'pages.fund-cash.purchase.saveDraft.link' | translate }}
        </ion-button>
      </div>

      <div class="flex ion-align-items-center ion-padding-horizontal justify-content-center" *ngIf="isSuperBuyer$ | async">
        <ion-button fill="clear" [disabled]="isFormInvalid || !isSuperBuyerInSubtask" (click)="openTransferModal()"
          >{{ 'pages.fund-cash.purchase.transfer.link' | translate }}
        </ion-button>
      </div>
    </ui-bottom-actions>
  </div>
</ion-content>
